// Module
var code = `<div div class="oe-selector" style="{{>visibility}}">
    <terceraLabel text="{{label}}" />

    <div class="oe-selector-right">
        <terceraInstrumentLookup enabled="{{enabled}}" mayContainTrees="true" selectedItem="{{instrument}}" selectedAccount="{{account}}" />
    </div>
</div>`;
// Exports
export default code;